import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';

const routes: Routes = [
  {path: '', component: HomeThreeComponent},
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
